export const mockupFormDataEmail = [
    {
        name: 'SFID',
        value: '30000235<br>\n',
    },
    {
        name: 'BAZA_SALES',
        value: 'BAZY_ZEWNETRZNE_LEADY_WWW<br>\n',
    },
    {
        name: 'ZDARZENIE',
        value: 'Lead_WWW_Pozyskanie<br>\n',
    },
    {
        name: 'TYP',
        value: 'POZYSKANIE<br>\n',
    },
    {
        name: 'OPIS',
        value: 'Test Przemka newsletter<br>\n',
    },
    {
        name: 'SOW',
        value: 'TAK<br>\n',
    },
    {
        name: 'FORM_URL',
        value: '/<br>\n',
    },
    {
        name: 'LEAD_ID',
        value: '457-35-10-19-5-2024-90<br>\n',
    },
    {
        name: 'utm_medium',
        value: '<br>\n',
    },
    {
        name: 'utm_source',
        value: '<br>\n',
    },
    {
        name: 'utm_campaign',
        value: '<br>\n',
    },
    {
        name: 'utm_content',
        value: '<br>\n',
    },
    {
        name: 'utm_term',
        value: '<br>\n',
    },
    {
        name: 'adfcd',
        value: '<br>\n',
    },
    {
        name: 'dclid',
        value: '<br>\n',
    },
    {
        name: 'gclid',
        value: '<br>\n',
    },
]
